<script>
  import { onMount, onDestroy, createEventDispatcher } from "svelte";

  export let sitekey = "0x4AAAAAABNpstnqCftFdFkw";
  export let theme = "dark";
  export let language = "uk";

  const dispatch = createEventDispatcher();
  let widgetId;
  let containerId = `cf-turnstile-${Math.random().toString(36).substr(2, 9)}`; // уникальный ID

  // удаление дубликатов iframe
  function removeAllTurnstileFrames() {
    const frames = document.querySelectorAll(
      'iframe[src*="challenges.cloudflare.com"]'
    );
    frames.forEach((frame) => frame.closest("div")?.remove());
  }

  onMount(() => {
    if (typeof window === "undefined") return;

    removeAllTurnstileFrames();

    const interval = setInterval(() => {
      if (window.turnstile) {
        clearInterval(interval);

        widgetId = window.turnstile.render(`#${containerId}`, {
          sitekey,
          theme,
          language,
          callback: (token) => {
            dispatch("token", token);
          },
        });
      }
    }, 100);
  });

  onDestroy(() => {
    if (
      typeof window !== "undefined" &&
      window.turnstile &&
      widgetId !== undefined
    ) {
      try {
        window.turnstile.remove(widgetId);
      } catch (e) {
        console.warn("Не вдалося видалити Turnstile:", e);
      }
    }
  });
</script>

<div id={containerId}></div>
